import { render, staticRenderFns } from "./PlantDetailForm.vue?vue&type=template&id=2412898c&scoped=true"
import script from "./PlantDetailForm.vue?vue&type=script&lang=ts"
export * from "./PlantDetailForm.vue?vue&type=script&lang=ts"
import style0 from "./PlantDetailForm.vue?vue&type=style&index=0&id=2412898c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2412898c",
  null
  
)

export default component.exports